import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import play from './icon-operation.png';
import stopAllIcon from './icon--stop-all.svg';
import styles from './stop-all.css';
import greenFlagIcon from "../green-flag/icon--green-flag.svg";

const StopAllComponent = function (props) {
    const {
        active,
        className,
        isMobile,
        onClick,
        title,
        ...componentProps
    } = props;
    let content = null;
    if (isMobile) {
        content = (
            <div className={styles.isMobile}>
                <img
                    src={stopAllIcon}
                    title={title}
                    onClick={onClick}
                    {...componentProps}
                />
            </div>
        )
    } else {
        content = (
            <img
                className={classNames(
                    className,
                    styles.stopAll,
                    {
                        [styles.isActive]: active
                    }
                )}
                draggable={false}
                src={stopAllIcon}
                title={title}
                onClick={onClick}
                {...componentProps}
            />
        )
    }
    return content;
};

StopAllComponent.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string
};

StopAllComponent.defaultProps = {
    active: false,
    title: 'Stop'
};

export default StopAllComponent;
